import {
    ClientValidationErrorKeys,
    type ClientValidationErrorResponse,
    type TypedClientError,
} from '@/components/Views/Company/File/Client/client-info-form.types';

const fieldMapping: Record<string, ClientValidationErrorKeys> = {
    first_name: ClientValidationErrorKeys.FIRST_NAME,
    last_name: ClientValidationErrorKeys.LAST_NAME,
    email: ClientValidationErrorKeys.EMAIL,
    phone: ClientValidationErrorKeys.PHONE,
    role: ClientValidationErrorKeys.ROLE,
};

export const createEmptyErrors = (): TypedClientError => {
    return {
        [ClientValidationErrorKeys.EMAIL]: '',
        [ClientValidationErrorKeys.PHONE]: '',
        [ClientValidationErrorKeys.ROLE]: '',
        [ClientValidationErrorKeys.FIRST_NAME]: '',
        [ClientValidationErrorKeys.LAST_NAME]: '',
    };
};

export const isClientValidationErrorKey = (value: string): value is ClientValidationErrorKeys => {
    return Object.values(ClientValidationErrorKeys).includes(value as ClientValidationErrorKeys);
};

export const parseErrorFieldInfo = (errorKey: string): { index: number; field: string } | undefined => {
    const indexedMatch = errorKey.match(/^clients\.(\d+)\.(\w+)$/);
    if (!indexedMatch) return;

    return {
        index: parseInt(indexedMatch[1], 10),
        field: indexedMatch[2],
    };
};

export const parseBackendErrorToTyped = (backendErrors: ClientValidationErrorResponse): TypedClientError => {
    const errors = createEmptyErrors();

    Object.entries(backendErrors).forEach(([key, messages]) => {
        const mapped = fieldMapping[key];
        if (mapped) {
            errors[mapped] = messages[0] || '';
        }
    });

    return errors;
};
